/* Maison Empereur — <me-quick-add-component>
   Sous-classe du quick-add natif Horizon (classe exportée par quick-add.js).
   Seule différence : la modale est remplie depuis la section dédiée
   `me-quick-add-product` (Section Rendering API) au lieu de la page produit
   entière — notre PDP forkée (me-pdp) n'a pas l'attribut
   [data-product-grid-content] que le natif extrait, et son markup me-* ne
   serait pas stylé hors page produit. Bonus : fragment de quelques Ko au lieu
   de la PDP complète (galerie incluse).
   Tout le reste (cache, abort, remontage mobile, sync variante carte→modale,
   dialog natif #quick-add-dialog) est hérité tel quel. */

import { QuickAddComponent } from '@theme/quick-add';

class MeQuickAddComponent extends QuickAddComponent {
  /**
   * @param {string} productPageUrl - URL produit (cache et liens restent sur
   *   l'URL propre ; le paramètre section_id n'est ajouté qu'au moment du fetch)
   * @returns {Promise<Document | null>}
   */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return super.fetchProductPage(productPageUrl);
    const url = new URL(productPageUrl, window.location.origin);
    url.searchParams.set('section_id', 'me-quick-add-product');
    return super.fetchProductPage(url.toString());
  }
}

if (!customElements.get('me-quick-add-component')) {
  customElements.define('me-quick-add-component', MeQuickAddComponent);
}
